import { useTranslations } from 'next-intl';
import { ReactNode } from 'react';
import { VariantProps } from 'tailwind-variants';

import { styles } from './LevelCard.styles';

type Variants = VariantProps<typeof styles>;

export interface LevelCardProps {
  level: number;
  description: string;
  cashback: number;
  privileges: {
    description: string;
    icon: React.ReactNode;
  }[];
  steps: string[] | ReactNode[];
  color?: Variants['color'];
}

export function LevelCard({
  level,
  description,
  cashback,
  privileges,
  steps,
  color = 'primary'
}: LevelCardProps) {
  const slots = styles({ color });

  const t = useTranslations('article.page.loyalty.levels');

  return (
    <div className={slots.base()}>
      <div className={slots.header()}>
        <div className={slots.left()}>
          <h3 className={slots.title()}>{t('level', { level })}</h3>
          <div className={slots.description()}>{description}</div>
        </div>

        <div className={slots.cashback()}>
          <div className={slots.cashbackPoints()}>{t('cashbackPoints')}</div>
          <div className={slots.cashbackValue()}>
            {cashback}
            <span className={slots.cashbackValuePercent()}>%</span>
          </div>
        </div>
      </div>

      <div className={slots.privilegesContainer()}>
        <h3 className={slots.subTitle()}>{t('privileges')}</h3>
        <div className={slots.privileges()}>
          {privileges.map((privilege) => (
            <div
              key={privilege.description}
              className={slots.privilegesItem()}
            >
              <div className={slots.privilegesItemIcon()}>{privilege.icon}</div>
              <div className={slots.privilegesItemDescription()}>
                {privilege.description}
              </div>
            </div>
          ))}
        </div>
      </div>

      <div>
        <h3 className={slots.subTitle()}>{t('steps')}</h3>
        <div className={slots.steps()}>
          {steps.map((step, index) => (
            <div
              key={index}
              className={slots.step()}
            >
              <div className={slots.stepNumber()}>0{index + 1}</div>
              <div className={slots.stepDescription()}>{step}</div>
            </div>
          ))}
        </div>
      </div>
    </div>
  );
}
